import React from 'react'
import { FormattedMessage } from 'react-intl'

export const hoursMsg = (<FormattedMessage
  id="TimeInput.hours"
  description="Label on an input for number of hours"
  defaultMessage="Hours"
/>)

export const minutesMsg = (<FormattedMessage
  id="TimeInput.minutes"
  description="Label on an input for number of minutes"
  defaultMessage="Minutes"
/>)

export const updateMsg = (<FormattedMessage
  id="TimeInput.update"
  description="Text on button"
  defaultMessage="Update"
/>)
